var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGifRectangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 180,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 3.457c.74 0 1.344-.6 1.344-1.344 0-.741-.605-1.344-1.344-1.344C1.605.769 1 1.372 1 2.113c0 .743.605 1.344 1.346 1.344z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 3.457c.74 0 1.344-.6 1.344-1.344 0-.741-.605-1.344-1.344-1.344C1.605.769 1 1.372 1 2.113c0 .743.605 1.344 1.346 1.344",
    stroke: "red"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 3.457a1.345 1.345 0 10.003-2.69 1.345 1.345 0 00-.003 2.69z",
    fill: "red"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 3.457a1.345 1.345 0 10.003-2.69 1.345 1.345 0 00-.003 2.69",
    stroke: "red"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 3.457a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 3.457a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 3.457a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 3.457a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 3.457A1.344 1.344 0 1056.19.77a1.344 1.344 0 00.004 2.687z",
    fill: "red"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 3.457A1.344 1.344 0 1056.19.77a1.344 1.344 0 00.004 2.687",
    stroke: "red"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 3.457a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 3.457a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 16.92c.74 0 1.344-.6 1.344-1.344a1.345 1.345 0 00-2.69 0c0 .744.605 1.345 1.346 1.345z",
    fill: "red"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 16.92c.74 0 1.344-.6 1.344-1.344a1.345 1.345 0 00-2.69 0c0 .744.605 1.345 1.346 1.345",
    stroke: "red"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 16.92a1.345 1.345 0 10.003-2.689 1.345 1.345 0 00-.003 2.69z",
    fill: "red"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 16.92a1.345 1.345 0 10.003-2.689 1.345 1.345 0 00-.003 2.69",
    stroke: "red"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 16.92a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.689z",
    fill: "red"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 16.92a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.689",
    stroke: "red"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 16.92a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.689z",
    fill: "red"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 16.92a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.689",
    stroke: "red"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 16.92a1.344 1.344 0 10-.003-2.687 1.344 1.344 0 00.003 2.688z",
    fill: "red"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 16.92a1.344 1.344 0 10-.003-2.687 1.344 1.344 0 00.003 2.688",
    stroke: "red"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 16.92a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.689z",
    fill: "red"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 16.92a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.689",
    stroke: "red"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 30.382c.74 0 1.344-.602 1.344-1.344 0-.74-.605-1.344-1.344-1.344-.741 0-1.346.603-1.346 1.344 0 .742.605 1.344 1.346 1.344z",
    fill: "red"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 30.382c.74 0 1.344-.602 1.344-1.344 0-.74-.605-1.344-1.344-1.344-.741 0-1.346.603-1.346 1.344 0 .742.605 1.344 1.346 1.344",
    stroke: "red"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 30.382c.743 0 1.346-.602 1.346-1.344a1.345 1.345 0 10-1.346 1.344z",
    fill: "red"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 30.382c.743 0 1.346-.602 1.346-1.344a1.345 1.345 0 10-1.346 1.344",
    stroke: "red"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 30.382c.741 0 1.344-.602 1.344-1.344 0-.74-.603-1.344-1.344-1.344-.741 0-1.344.603-1.344 1.344 0 .742.603 1.344 1.344 1.344z",
    fill: "red"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 30.382c.741 0 1.344-.602 1.344-1.344 0-.74-.603-1.344-1.344-1.344-.741 0-1.344.603-1.344 1.344 0 .742.603 1.344 1.344 1.344",
    stroke: "red"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 30.382c.742 0 1.345-.602 1.345-1.344 0-.74-.603-1.344-1.344-1.344-.74 0-1.344.603-1.344 1.344 0 .742.605 1.344 1.344 1.344z",
    fill: "red"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 30.382c.742 0 1.345-.602 1.345-1.344 0-.74-.603-1.344-1.344-1.344-.74 0-1.344.603-1.344 1.344 0 .742.605 1.344 1.344 1.344",
    stroke: "red"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 30.382a1.345 1.345 0 000-2.688c-.742 0-1.346.603-1.346 1.344 0 .742.605 1.344 1.346 1.344z",
    fill: "red"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 30.382a1.345 1.345 0 000-2.688c-.742 0-1.346.603-1.346 1.344 0 .742.605 1.344 1.346 1.344",
    stroke: "red"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 30.382c.74 0 1.344-.602 1.344-1.344 0-.74-.603-1.344-1.344-1.344-.742 0-1.344.603-1.344 1.344 0 .742.602 1.344 1.344 1.344z",
    fill: "red"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 30.382c.74 0 1.344-.602 1.344-1.344 0-.74-.603-1.344-1.344-1.344-.742 0-1.344.603-1.344 1.344 0 .742.602 1.344 1.344 1.344",
    stroke: "red"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 43.844c.74 0 1.344-.6 1.344-1.344a1.345 1.345 0 00-2.69 0c0 .743.605 1.344 1.346 1.344z",
    fill: "red"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 43.844c.74 0 1.344-.6 1.344-1.344a1.345 1.345 0 00-2.69 0c0 .743.605 1.344 1.346 1.344",
    stroke: "red"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 43.844a1.345 1.345 0 10.003-2.69 1.345 1.345 0 00-.003 2.69z",
    fill: "red"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 43.844a1.345 1.345 0 10.003-2.69 1.345 1.345 0 00-.003 2.69",
    stroke: "red"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 43.844a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 43.844a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 43.844a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 43.844a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 43.844a1.344 1.344 0 10-.004-2.687 1.344 1.344 0 00.004 2.687z",
    fill: "red"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 43.844a1.344 1.344 0 10-.004-2.687 1.344 1.344 0 00.004 2.687",
    stroke: "red"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 43.844a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 43.844a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 57.308c.74 0 1.344-.603 1.344-1.344a1.345 1.345 0 00-2.69 0c0 .741.605 1.344 1.346 1.344z",
    fill: "red"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 57.308c.74 0 1.344-.603 1.344-1.344a1.345 1.345 0 00-2.69 0c0 .741.605 1.344 1.346 1.344",
    stroke: "red"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 57.308a1.345 1.345 0 10.003-2.687 1.345 1.345 0 00-.003 2.687z",
    fill: "red"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 57.308a1.345 1.345 0 10.003-2.687 1.345 1.345 0 00-.003 2.687",
    stroke: "red"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 57.308a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 57.308a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 57.308a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 57.308a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 57.308a1.345 1.345 0 000-2.688c-.742 0-1.346.6-1.346 1.344 0 .741.605 1.344 1.346 1.344z",
    fill: "red"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 57.308a1.345 1.345 0 000-2.688c-.742 0-1.346.6-1.346 1.344 0 .741.605 1.344 1.346 1.344",
    stroke: "red"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 57.308a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 57.308a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 70.768c.74 0 1.344-.601 1.344-1.344 0-.74-.605-1.345-1.344-1.345-.741 0-1.346.605-1.346 1.345 0 .743.605 1.344 1.346 1.344z",
    fill: "red"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 70.768c.74 0 1.344-.601 1.344-1.344 0-.74-.605-1.345-1.344-1.345-.741 0-1.346.605-1.346 1.345 0 .743.605 1.344 1.346 1.344",
    stroke: "red"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 70.768a1.344 1.344 0 10.003-2.69 1.344 1.344 0 00-.003 2.69z",
    fill: "red"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 70.768a1.344 1.344 0 10.003-2.69 1.344 1.344 0 00-.003 2.69",
    stroke: "red"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 70.768a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 70.768a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 70.768a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 70.768a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 70.768a1.344 1.344 0 10-.003-2.688 1.344 1.344 0 00.003 2.688z",
    fill: "red"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 70.768a1.344 1.344 0 10-.003-2.688 1.344 1.344 0 00.003 2.688",
    stroke: "red"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 70.768a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 70.768a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 84.232c.74 0 1.344-.601 1.344-1.344a1.345 1.345 0 00-2.69 0c0 .743.605 1.344 1.346 1.344z",
    fill: "red"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 84.232c.74 0 1.344-.601 1.344-1.344a1.345 1.345 0 00-2.69 0c0 .743.605 1.344 1.346 1.344",
    stroke: "red"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 84.232a1.345 1.345 0 10.003-2.69 1.345 1.345 0 00-.003 2.69z",
    fill: "red"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 84.232a1.345 1.345 0 10.003-2.69 1.345 1.345 0 00-.003 2.69",
    stroke: "red"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 84.232a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 84.232a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 84.232a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 84.232a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 84.232a1.344 1.344 0 10-.003-2.688 1.344 1.344 0 00.003 2.688z",
    fill: "red"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 84.232a1.344 1.344 0 10-.003-2.688 1.344 1.344 0 00.003 2.688",
    stroke: "red"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 84.232a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 84.232a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 98.457c.74 0 1.344-.6 1.344-1.344 0-.741-.605-1.344-1.344-1.344-.741 0-1.346.603-1.346 1.344 0 .743.605 1.344 1.346 1.344z",
    fill: "red"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 98.457c.74 0 1.344-.6 1.344-1.344 0-.741-.605-1.344-1.344-1.344-.741 0-1.346.603-1.346 1.344 0 .743.605 1.344 1.346 1.344",
    stroke: "red"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 98.457a1.344 1.344 0 10.003-2.69 1.344 1.344 0 00-.003 2.69z",
    fill: "red"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 98.457a1.344 1.344 0 10.003-2.69 1.344 1.344 0 00-.003 2.69",
    stroke: "red"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 98.457a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 98.457a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 98.457a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 98.457a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 98.457a1.344 1.344 0 10-.004-2.687 1.344 1.344 0 00.004 2.687z",
    fill: "red"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 98.457a1.344 1.344 0 10-.004-2.687 1.344 1.344 0 00.004 2.687",
    stroke: "red"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 98.457a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 98.457a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 111.921a1.346 1.346 0 000-2.689c-.741 0-1.346.601-1.346 1.344 0 .744.605 1.345 1.346 1.345z",
    fill: "red"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 111.921a1.346 1.346 0 000-2.689c-.741 0-1.346.601-1.346 1.344 0 .744.605 1.345 1.346 1.345",
    stroke: "red"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 111.921a1.345 1.345 0 10.002-2.69 1.345 1.345 0 00-.002 2.69z",
    fill: "red"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 111.921a1.345 1.345 0 10.002-2.69 1.345 1.345 0 00-.002 2.69",
    stroke: "red"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 111.921a1.344 1.344 0 10-.001-2.689 1.344 1.344 0 000 2.689z",
    fill: "red"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 111.921a1.344 1.344 0 10-.001-2.689 1.344 1.344 0 000 2.689",
    stroke: "red"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 111.921a1.344 1.344 0 100-2.689 1.344 1.344 0 000 2.689z",
    fill: "red"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 111.921a1.344 1.344 0 100-2.689 1.344 1.344 0 000 2.689",
    stroke: "red"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 111.921a1.344 1.344 0 10-.004-2.688 1.344 1.344 0 00.004 2.688z",
    fill: "red"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 111.921a1.344 1.344 0 10-.004-2.688 1.344 1.344 0 00.004 2.688",
    stroke: "red"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 111.921a1.344 1.344 0 10-.001-2.689 1.344 1.344 0 000 2.689z",
    fill: "red"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 111.921a1.344 1.344 0 10-.001-2.689 1.344 1.344 0 000 2.689",
    stroke: "red"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 125.382c.74 0 1.344-.602 1.344-1.344 0-.741-.605-1.344-1.344-1.344-.741 0-1.346.603-1.346 1.344 0 .742.605 1.344 1.346 1.344z",
    fill: "red"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 125.382c.74 0 1.344-.602 1.344-1.344 0-.741-.605-1.344-1.344-1.344-.741 0-1.346.603-1.346 1.344 0 .742.605 1.344 1.346 1.344",
    stroke: "red"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 125.382c.743 0 1.346-.602 1.346-1.344a1.345 1.345 0 10-1.346 1.344z",
    fill: "red"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 125.382c.743 0 1.346-.602 1.346-1.344a1.345 1.345 0 10-1.346 1.344",
    stroke: "red"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 125.382a1.345 1.345 0 000-2.688 1.345 1.345 0 000 2.688z",
    fill: "red"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 125.382a1.345 1.345 0 000-2.688 1.345 1.345 0 000 2.688",
    stroke: "red"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 125.382a1.345 1.345 0 000-2.688c-.738 0-1.343.603-1.343 1.344 0 .742.605 1.344 1.344 1.344z",
    fill: "red"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 125.382a1.345 1.345 0 000-2.688c-.738 0-1.343.603-1.343 1.344 0 .742.605 1.344 1.344 1.344",
    stroke: "red"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 125.382a1.344 1.344 0 10-.005-2.689 1.344 1.344 0 00.005 2.689z",
    fill: "red"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 125.382a1.344 1.344 0 10-.005-2.689 1.344 1.344 0 00.005 2.689",
    stroke: "red"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 125.382a1.345 1.345 0 000-2.688 1.345 1.345 0 000 2.688z",
    fill: "red"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 125.382a1.345 1.345 0 000-2.688 1.345 1.345 0 000 2.688",
    stroke: "red"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 138.844a1.345 1.345 0 10-.002-2.686 1.345 1.345 0 00.002 2.686z",
    fill: "red"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 138.844a1.345 1.345 0 10-.002-2.686 1.345 1.345 0 00.002 2.686",
    stroke: "red"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 138.844a1.345 1.345 0 10.003-2.69 1.345 1.345 0 00-.003 2.69z",
    fill: "red"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 138.844a1.345 1.345 0 10.003-2.69 1.345 1.345 0 00-.003 2.69",
    stroke: "red"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 138.844a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 138.844a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 138.844a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 138.844a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 138.844a1.344 1.344 0 10-.004-2.688 1.344 1.344 0 00.004 2.688z",
    fill: "red"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 138.844a1.344 1.344 0 10-.004-2.688 1.344 1.344 0 00.004 2.688",
    stroke: "red"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 138.844a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 138.844a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 152.308c.74 0 1.344-.603 1.344-1.344a1.346 1.346 0 00-2.69 0c0 .741.605 1.344 1.346 1.344z",
    fill: "red"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 152.308c.74 0 1.344-.603 1.344-1.344a1.346 1.346 0 00-2.69 0c0 .741.605 1.344 1.346 1.344",
    stroke: "red"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 152.308a1.345 1.345 0 10.003-2.687 1.345 1.345 0 00-.003 2.687z",
    fill: "red"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 152.308a1.345 1.345 0 10.003-2.687 1.345 1.345 0 00-.003 2.687",
    stroke: "red"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 152.308a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 152.308a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 152.308a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 152.308a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 152.308a1.345 1.345 0 000-2.688c-.742 0-1.346.601-1.346 1.344 0 .741.605 1.344 1.346 1.344z",
    fill: "red"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 152.308a1.345 1.345 0 000-2.688c-.742 0-1.346.601-1.346 1.344 0 .741.605 1.344 1.346 1.344",
    stroke: "red"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 152.308a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 152.308a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 165.768c.74 0 1.344-.601 1.344-1.344 0-.74-.605-1.344-1.344-1.344-.741 0-1.346.604-1.346 1.344 0 .743.605 1.344 1.346 1.344z",
    fill: "red"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 165.768c.74 0 1.344-.601 1.344-1.344 0-.74-.605-1.344-1.344-1.344-.741 0-1.346.604-1.346 1.344 0 .743.605 1.344 1.346 1.344",
    stroke: "red"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 165.768a1.345 1.345 0 10.003-2.69 1.345 1.345 0 00-.003 2.69z",
    fill: "red"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 165.768a1.345 1.345 0 10.003-2.69 1.345 1.345 0 00-.003 2.69",
    stroke: "red"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 165.768a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 165.768a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 165.768a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 165.768a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 165.768a1.344 1.344 0 10-.004-2.688 1.344 1.344 0 00.004 2.688z",
    fill: "red"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 165.768a1.344 1.344 0 10-.004-2.688 1.344 1.344 0 00.004 2.688",
    stroke: "red"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 165.768a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 165.768a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.346 179.232a1.345 1.345 0 10-.002-2.686 1.345 1.345 0 00.002 2.686z",
    fill: "red"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M2.346 179.232a1.345 1.345 0 10-.002-2.686 1.345 1.345 0 00.002 2.686",
    stroke: "red"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 179.232a1.345 1.345 0 10.003-2.69 1.345 1.345 0 00-.003 2.69z",
    fill: "red"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M15.807 179.232a1.345 1.345 0 10.003-2.69 1.345 1.345 0 00-.003 2.69",
    stroke: "red"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 179.232a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M29.27 179.232a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.73 179.232a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 179.232a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.194 179.232a1.344 1.344 0 10-.004-2.688 1.344 1.344 0 00.004 2.688z",
    fill: "red"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M56.194 179.232a1.344 1.344 0 10-.004-2.688 1.344 1.344 0 00.004 2.688",
    stroke: "red"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.657 179.232a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688z",
    fill: "red"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M69.657 179.232a1.344 1.344 0 100-2.688 1.344 1.344 0 000 2.688",
    stroke: "red"
  })));
}

export default __webpack_public_path__ + "static/gif-rectangle.fbc319f5.svg";
export { SvgGifRectangle as ReactComponent };